// CSS Modules - component class name prefix: HeroSlider__

<template>
  <div :class="[{ HeroSlider__heightFirst: heightFirst }, $style.container]">
    <agile
      v-if="isActive"
      :dots="slides && slides.length > 1"
      :navButtons="slides && slides.length > 1"
      :fade="true"
      :speed="500"
      :autoplay="true"
      :autoplaySpeed="7000"
    >
      <figure
        :class="$style.slide"
        v-for="(slide, index) in slides"
        :key="`${slide.text}_${index}`"
      >
        <HeroSlideProduct
          v-if="slide.product"
          :slide="slide"
          :heightFirst="heightFirst"
          :index="index"
        />
        <HeroSlide
          v-else
          :slide="slide"
          :heightFirst="heightFirst"
          :index="index"
        />
      </figure>
      <template slot="prevButton">
        <ChevronLeft />
      </template>
      <template slot="nextButton">
        <ChevronRight />
      </template>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from "../vue-agile";
import { isIE } from "mobile-device-detect";
import ChevronLeft from "../../assets/svg/ChevronLeft";
import ChevronRight from "../../assets/svg/ChevronRight";
import HeroSlide from "./HeroSlide";
import HeroSlideProduct from "./HeroSlideProduct";

export default {
  name: "HeroSlider",
  components: {
    agile: VueAgile,
    ChevronLeft,
    ChevronRight,
    HeroSlide,
    HeroSlideProduct
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    heightFirst: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      wtTrack: window.wtTrack
    };
  },
  mounted() {
    if (isIE) {
      setTimeout(() => {
        this.isActive = true;
      }, 500);
    } else {
      this.isActive = true;
    }
  }
};
</script>

<style module lang="scss">
@import "./HeroSlider.scss";
</style>
